import * as React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';

const AdjustableBaseModalButton: React.FC<{
    onClick: Function;
    isAdjustableModalVisible: boolean;
    children?: React.ReactNode;
}> = props => {
    return (
        <>
            <Node
                onClick={() => {
                    props.onClick();
                }}
                className={''}
            >
                <Node className={props.isAdjustableModalVisible ? 'msc-modal-value-toggle focused' : 'msc-modal-value-toggle'} tabIndex='0'>
                    <div className={'my-auto msc-adjustable-base-modal-label msc-selected-size-label'}>
                        <div className='row'>{props.children}</div>
                    </div>
                </Node>
            </Node>
        </>
    );
};

export default AdjustableBaseModalButton;
